webpackJsonp([1],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__online__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__test__ = __webpack_require__(199);




var config = function () {
  return (/\.biz/.test(location.host) ? __WEBPACK_IMPORTED_MODULE_2__test__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__online__["a" /* default */]
  );
}();

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, config));

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(118);






var Utils = function () {
  function Utils() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Utils);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Utils, null, [{
    key: 'getYear',
    value: function getYear() {
      return new Date().getFullYear();
    }
  }, {
    key: 'isIOS',
    value: function isIOS() {
      return (/iP(hone|od|ad)/.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isIPhone',
    value: function isIPhone() {
      return (/iP(hone|od)/.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isIPad',
    value: function isIPad() {
      return (/iPad/.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isAndroid',
    value: function isAndroid() {
      return (/Android/.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isYuanTiku',
    value: function isYuanTiku() {
      return (/YuanTiKu/i.test(navigator.userAgent) && !/YuanTiKuEmbed/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isYuanFuDao',
    value: function isYuanFuDao() {
      return (/YuanFuDao|YuanTiKuEmbed/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isYuanTiKuEmbed',
    value: function isYuanTiKuEmbed() {
      return (/YuanTiKuEmbed/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isYuanSouTi',
    value: function isYuanSouTi() {
      return (/YuanSouTi/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isApp',
    value: function isApp() {
      return Utils.isYuanTiku() || Utils.isYuanFuDao() || Utils.isYuanSouTi() || Utils.isYuanTiKuEmbed();
    }
  }, {
    key: 'isWechat',
    value: function isWechat() {
      return (/micromessenger/i.test(navigator.userAgent.toLowerCase())
      );
    }
  }, {
    key: 'isQQ',
    value: function isQQ() {
      return (/QQ/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'isWeibo',
    value: function isWeibo() {
      return (/weibo/i.test(navigator.userAgent.toLowerCase())
      );
    }
  }, {
    key: 'getAppId',
    value: function getAppId() {
      return Utils.isYuanSouTi() ? 201 : Utils.isYuanTiku() ? 101 : 0;
    }
  }, {
    key: 'getAppVersion',
    value: function getAppVersion() {
      var UA_REGEX = /\s+(YuanTiKu|YuanFuDao|YuanSouTi)\/(\d+\.\d+\.\d+)(\s+|$)/i;
      var ua = window.navigator.userAgent;
      var matches = ua.match(UA_REGEX);
      return matches ? matches[2] : '';
    }
  }, {
    key: 'queryConfig',
    value: function queryConfig() {
      return {
        _productId: 241,
        _appId: Utils.getAppId()
      };
    }
  }, {
    key: 'extendQuery',
    value: function extendQuery(query) {
      return __WEBPACK_IMPORTED_MODULE_3_underscore___default.a.extend(query || {}, Utils.queryConfig());
    }
  }, {
    key: 'verifyPhone',
    value: function verifyPhone(phone) {
      return (/^1[3-9]\d{9}$/.test(phone)
      );
    }
  }, {
    key: 'verifyVerificationCode',
    value: function verifyVerificationCode(code) {
      return String(code).length === 6;
    }
  }, {
    key: 'isOnline',
    value: function isOnline() {
      return navigator.onLine;
    }
  }, {
    key: 'navigateToYuanSouTi',
    value: function navigateToYuanSouTi() {
      window.location = 'https:' + __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].SOLAR_HOST + '/app-download';
    }
  }, {
    key: 'getUrlSchemaPrefix',
    value: function getUrlSchemaPrefix() {
      return Utils.isIPad() ? 'solar-ipad://' : 'solar://';
    }
  }, {
    key: 'getQuestionDetailUrl',
    value: function getQuestionDetailUrl(token, isNew) {
      return Utils.getUrlSchemaPrefix() + 'solar/questionDetail?token=' + token + '&type=2&authType=10&isShareInvite=' + !!isNew;
    }
  }, {
    key: 'getOpenWebViewUrl',
    value: function getOpenWebViewUrl(url) {
      return Utils.getUrlSchemaPrefix() + 'openWebView?url=' + url;
    }
  }, {
    key: 'addFrog',
    value: function addFrog(frog, url, params) {
      var paramsList = [];
      var appId = Utils.queryConfig()._appId;
      paramsList.push('appId=' + appId);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (key && params[key]) {
          paramsList.push(key + '=' + params[key]);
        }
      });
      frog.add(url + '?' + paramsList.join('&'));
    }
  }, {
    key: 'getParam',
    value: function getParam(key) {
      var search = window.location.search;
      if (search) {
        search = search.substring(1);
        var params = search.split('&');
        for (var i = 0; i < params.length; i++) {
          var temp = params[i].split('=');
          if (temp[0] === key) {
            return temp[1];
          }
        }
      }
      return null;
    }
  }, {
    key: 'preventDefault',
    value: function preventDefault(e) {
      if (!window.ifDisableScroll) {
        return;
      }
      if (!e.target.className || e.target.className.indexOf('scrollable') === -1) {
        e.preventDefault();
      }
      e.stopPropagation();
    }
  }, {
    key: 'enableScroll',
    value: function enableScroll() {
      if (!Utils.isIOS() || !Utils.isAndroid()) {
        document.body.style.overflow = '';
      }
      window.ifDisableScroll = false;
      window.removeEventListener('scroll', Utils.preventDefault);
      window.removeEventListener('touchmove', Utils.preventDefault);
    }
  }, {
    key: 'disableScroll',
    value: function disableScroll() {
      if (!Utils.isIOS() || !Utils.isAndroid()) {
        document.body.style.overflow = 'hidden';
      }
      window.ifDisableScroll = true;
      window.addEventListener('scroll', Utils.preventDefault, { passive: false });
      window.addEventListener('touchmove', Utils.preventDefault, { passive: false });
    }
  }, {
    key: 'fixAutofocus',
    value: function fixAutofocus() {
      document.querySelector('input[autofocus]').focus();
    }
  }]);

  return Utils;
}();

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  parse: function parse(search) {
    search = search || window.location.search;
    var query = {};
    if (search) {
      search = search.trim().replace(/^\?/, '');
      search.split('&').forEach(function (param) {
        var parts = param.split('=');
        query[parts[0]] = parts[1] ? decodeURIComponent(parts[1]) : null;
      });
    }
    return query;
  }
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var UA = function () {
  function UA() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UA);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UA, null, [{
    key: "isYuanTiku",
    value: function isYuanTiku() {
      return (/YuanTiKu/i.test(navigator.userAgent)
      );
    }
  }, {
    key: "isYuanFuDao",
    value: function isYuanFuDao() {
      return (/YuanFuDao/i.test(navigator.userAgent)
      );
    }
  }, {
    key: "isYuanSouTi",
    value: function isYuanSouTi() {
      return (/YuanSouTi/i.test(navigator.userAgent)
      );
    }
  }, {
    key: "getAppId",
    value: function getAppId() {
      if (UA.isYuanTiku()) {
        return 101;
      } else if (UA.isYuanSouTi()) {
        return 201;
      } else {
        return 0;
      }
    }
  }]);

  return UA;
}();

/* harmony default export */ __webpack_exports__["a"] = (UA);

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_frog__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Utils__ = __webpack_require__(119);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var render = function render() {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
    router: new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
      routes: [{ path: '/:status(\\d+)', name: 'main', component: __WEBPACK_IMPORTED_MODULE_2__components_MainPage___default.a }, { path: '*', redirect: '/1' }]
    }),
    template: '<App/>'
  });
};

if (__WEBPACK_IMPORTED_MODULE_6__utils_Utils__["a" /* default */].isYuanSouTi()) {
  __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getSolarUser().end(function (e, res) {
    window.ytkUserId = res.body.ytkUserId;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__plugins_frog__["a" /* default */], {
      fields: {
        userId: res.body.ytkUserId,
        solarUserId: res.body.userId,
        productId: 241
      }
    });
    render();
  });
} else {
  __WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getUser().then(function (res) {
    window.ytkUserId = res.body.id;
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__plugins_frog__["a" /* default */], {
      fields: {
        userId: res.body.id,
        productId: 241
      }
    });
    render();
  }).catch(function () {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__plugins_frog__["a" /* default */], {
      fields: {
        productId: 241
      }
    });
    render();
  });
}

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  YTK_HOST: '//ytk.yuanfudao.com',
  YST_HOST: '//xyst.yuanfudao.com',
  SOLAR_OPEN_HOST: '//xyst-open.yuanfudao.com',
  YTK_GALLERY: '//gallery.fbcontent.cn/api/ape/images/'
});

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  YTK_HOST: '//ytk1.yuanfudao.biz',
  YST_HOST: '//xyst.yuanfudao.biz',
  SOLAR_OPEN_HOST: '//xyst-open.yuanfudao.biz',
  YTK_GALLERY: '//ytkgallery.yuantiku.biz/api/ape/images/'
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__yuanfudao_frog__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_QueryUtil__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Utils__ = __webpack_require__(119);






var appendCommonKV = function appendCommonKV(keyValues) {
  var search = __WEBPACK_IMPORTED_MODULE_3__utils_QueryUtil__["a" /* default */].search();
  console.log('search++', search);
  keyValues.push({ key: 'from', value: search.from || '' });
  keyValues.push({ key: 'appId', value: __WEBPACK_IMPORTED_MODULE_4__utils_Utils__["a" /* default */].getAppId() });
  return keyValues;
};

var install = function install(Vue, options) {
  Vue.prototype.$addFrog = function (url, params) {
    var keyValues = [];
    params = params || {};
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      var value = params[key];
      keyValues.push({ key: key, value: value });
    });
    appendCommonKV(keyValues);
    if (window.ytkUserId) {
      options.fields.userId = window.ytkUserId;
    }
    if (window.solarUserId) {
      options.fields.solarUserId = window.solarUserId;
    }
    var extensions = [];
    if (options.fields.solarUserId) {
      extensions.push({
        key: 'solarUserId',
        value: options.fields.solarUserId
      });
    }
    console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options.fields, { keyValues: keyValues, extensions: extensions }));
    var ins = new __WEBPACK_IMPORTED_MODULE_2__yuanfudao_frog__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options.fields, { keyValues: keyValues, extensions: extensions }));
    ins.clear();
    ins.add(url);
    ins.send();
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({ install: install });

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search() {
    var query = window.location.search.substr(1);
    var result = {};
    query.split('&').forEach(function (part) {
      var item = part.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  },
  params2query: function params2query(params) {
    var paramsList = [];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (key && params[key]) {
        paramsList.push(key + '=' + params[key]);
      }
    });
    return '?' + paramsList.join('&');
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var rules = [];


var paperScale = {};

var scoreFormate = function scoreFormate(score) {
  return Math.round(score * 10) / 10;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getEstimateScore: function getEstimateScore(paperEstimates) {
    var paperScoreMap = {};
    var ignoredPaperIds = [];

    paperEstimates.forEach(function (estimate) {
      paperScoreMap[estimate.paperId] = estimate.status ? estimate.score : 0;
    });

    rules.forEach(function (rule) {
      var sortedIds = rule.paperIds.sort(function (a, b) {
        return paperScoreMap[b].score - paperScoreMap[a].score;
      });
      ignoredPaperIds = ignoredPaperIds.concat(sortedIds.slice(rule.n));
    });

    var sum = 0;
    paperEstimates.forEach(function (estimate) {
      if (estimate.status && estimate.paperId && ignoredPaperIds.indexOf(estimate.paperId) === -1) {
        sum += scoreFormate(estimate.score * (paperScale[estimate.paperId] || 1));
      }
    });
    return sum;
  },
  getPaperScore: function getPaperScore(paperEstimate) {
    return scoreFormate(paperEstimate.score * (paperScale[paperEstimate.paperId] || 1));
  }
});

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'city-cell',
  props: ['quiz', 'quizId', 'majorId'],
  methods: {
    selectQuiz: function selectQuiz() {
      this.$emit('select');
    }
  },
  computed: {
    disabled: function disabled() {
      var quiz = this.quiz,
          majorId = this.majorId;

      if (majorId === 0) {
        return quiz.id !== 817 && quiz.id !== 855 && quiz.id !== 841;
      } else if (majorId === 1 || majorId === 2) {
        return quiz.id === 817 || quiz.id === 855 || quiz.id === 841;
      }
      return false;
    }
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var searchString = window.location.search;
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'count-down',
  props: ['deadline', 'paperId'],
  mounted: function mounted() {
    if (this.deadline < new Date().getTime()) {
      this.already = true;
    }
    this.countdown();
  },
  data: function data() {
    return {
      diffTime: null,
      already: false,
      searchString: searchString
    };
  },

  methods: {
    countdown: function countdown() {
      var _this = this;

      this.getDiffTime();
      if (this.already) {
        return false;
      }
      setTimeout(function () {
        _this.countdown();
      }, 1000);
    },
    enterPaper: function enterPaper() {
      var _this2 = this;

      this.$addFrog('/click/evaluate2019/paper', { paperid: this.paperId });
      setTimeout(function () {
        window.location.href = '/h5/ape-web-homework_estimate/#/papers/' + _this2.paperId + '/estimate' + _this2.searchString;
      }, 200);
    },
    getDiffTime: function getDiffTime() {
      var seconds = (this.deadline - new Date().getTime()) / 1000;
      if (seconds < 0) {
        this.already = true;
        return false;
      }
      var h = parseInt(seconds / 3600, 10);
      var m = parseInt(seconds % 3600 / 60, 10);
      var s = parseInt(seconds % 3600 % 60, 10);
      var result = this.paddingZero(h) + ' : ' + this.paddingZero(m) + ' : ' + this.paddingZero(s);
      this.diffTime = result;
    },
    paddingZero: function paddingZero(num) {
      var result = num;
      if (result < 10) {
        result = '0' + result;
      }
      return result;
    }
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Loading',

  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobilePage__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobilePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MobilePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WebPage__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WebPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WebPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_base_css__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_base_css__);





var isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MainPage',
  components: {
    MobilePage: __WEBPACK_IMPORTED_MODULE_0__MobilePage___default.a,
    WebPage: __WEBPACK_IMPORTED_MODULE_1__WebPage___default.a
  },
  data: function data() {
    return {
      isMobile: isMobile
    };
  },
  beforeCreate: function beforeCreate() {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Personal__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Personal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Personal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CityCell__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CityCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CityCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ua__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_query__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__ = __webpack_require__(115);










var query = __WEBPACK_IMPORTED_MODULE_4__utils_query__["a" /* default */].parse();
var shareMap = {
  qq: '/click/evaluate2019Homepage/shareToQQ',
  qzone: '/click/evaluate2019Homepage/shareToQzone',
  wechat: '/click/evaluate2019Homepage/shareToWeixin',
  moments: '/click/evaluate2019Homepage/shareToMoments',
  weibo: '/click/evaluate2019Homepage/shareToWeibo'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mobile-page',
  components: {
    Personal: __WEBPACK_IMPORTED_MODULE_0__Personal___default.a, CityCell: __WEBPACK_IMPORTED_MODULE_1__CityCell___default.a
  },
  data: function data() {
    return {
      majors: [{
        id: 1,
        name: '文科'
      }, {
        id: 2,
        name: '理科'
      }, {
        id: 0,
        name: '文理不分科'
      }],
      quizzes: [],
      majorId: null,
      quizId: null,
      estimateStat: null,
      numbers: [0, 0, 0, 0, 0, 0],
      isLogin: false,

      keyfrom: query.keyfrom,
      appId: __WEBPACK_IMPORTED_MODULE_3__utils_ua__["a" /* default */].getAppId(),
      isGaosan: Number(query.isGaosan),
      type: Number(query.isGaosan) ? 2 : 1,
      wenanId: 255
    };
  },


  computed: {
    status: function status() {
      return Number(this.$route.params.status) || 1;
    },
    confirm: function confirm() {
      var majorId = this.majorId,
          quizId = this.quizId;

      if (majorId === 0) {
        return quizId === 817 || quizId === 855 || quizId === 841;
      } else if (majorId === 1 || majorId === 2) {
        return quizId > 0 && quizId !== 817 && quizId !== 855 && quizId !== 841;
      }
      return false;
    }
  },

  watch: {
    status: function status() {
      this.onStatusChange();
    }
  },

  created: function created() {
    var _this = this;

    this.onStatusChange();
    window.document.title = this.isGaosan ? '2019高考真题在线估分' : '2019高考真题挑战赛';
    if (__WEBPACK_IMPORTED_MODULE_3__utils_ua__["a" /* default */].isYuanSouTi()) {
      __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getSolarUser().then(function (res) {
        if (!res.body.trial) {
          _this.isLogin = true;
          window.ytkUserId = res.body.ytkUserId;
          window.solarUserId = res.body.userId;
        }
        if (_this.status === 2) {
          _this.changeQuiz();
        }
      }).catch(function () {
        if (_this.status === 2) {
          _this.changeQuiz();
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getUser().then(function (res) {
        if (!res.body.trial) {
          _this.isLogin = true;
          window.ytkUserId = res.body.id;
        }
        if (_this.status === 2) {
          _this.changeQuiz();
        }
      }).catch(function () {
        if (_this.status === 2) {
          _this.changeQuiz();
        }
      });
    }
    __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getEstimateStat(815, 2).then(function (res) {
      var userCount = '' + res.body.userCount;
      var count = '0'.repeat(6 - userCount.length) + userCount;
      _this.numbers = count.split('');
    });
    if (this.status === 1) {
      this.$addFrog('/event/evaluate2019Homepage/enter', { type: this.type });
    }
  },


  methods: {
    startEstimate: function startEstimate() {
      if (this.estimateStat) {
        this.$addFrog('/click/evaluate2019Homepage/start', { type: this.type, courseid: this.estimateStat.major.id, provinceid: this.estimateStat.quiz.id });
        this.changeStatus(3);
      }
    },
    selectSubject: function selectSubject(quiz) {
      if (this.majorId === 0 && quiz.id !== 817 && quiz.id !== 855 && quiz.id !== 841 || (this.majorId === 1 || this.majorId === 2) && (quiz.id === 817 || quiz.id === 855 || quiz.id === 841)) {
        return false;
      }
      this.quizId = quiz.id;
    },
    confirmSelect: function confirmSelect() {
      var _this2 = this;

      if (this.confirm) {
        __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setUserInfo(this.quizId, this.majorId).then(function (res) {
          _this2.getEstimateStat();
          _this2.changeStatus(1, true);
        });
      }
    },
    getEstimateStat: function getEstimateStat() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getEstimateStat(this.quizId, this.majorId).then(function (res) {
        _this3.estimateStat = res.body;
        _this3.majorId = _this3.estimateStat.major.id;
        _this3.quizId = _this3.estimateStat.quiz.id;
        var userCount = '' + _this3.estimateStat.userCount;
        var count = '0'.repeat(6 - userCount.length) + userCount;
        _this3.numbers = count.split('');
      });
    },
    changeStatus: function changeStatus(status, replace) {
      var _this4 = this;

      if (this.status === status) {
        return;
      }

      if (status !== 1) {
        this.checkLogin(function () {
          _this4.handleStatusChange(status, replace);
        });
      } else {
        this.handleStatusChange(status, replace);
      }
    },
    handleStatusChange: function handleStatusChange(status, replace) {
      this.status = status;
      if (replace) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'main', params: { status: status } });
      }
    },
    changeQuiz: function changeQuiz(param) {
      var _this5 = this;

      var type = this.type;

      if (param === 'init') {
        this.$addFrog('/click/evaluate2019Homepage/choose', { type: type });
      } else {
        this.$addFrog('/click/evaluate2019Homepage/change', { type: type });
      }
      this.checkLogin(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getQuizzes().then(function (res) {
          _this5.quizzes = res.body;
          _this5.changeStatus(2);
        }, function (err) {
          if (err.status === 401) {
            _this5.login();
          }
        });
      });
    },
    shareCallback: function shareCallback(err, platform) {
      var type = this.type;

      console.log(err, platform);
      this.$addFrog(shareMap[platform], { type: type });
    },
    onShare: function onShare() {
      var type = this.type;

      this.$addFrog('/click/evaluate2019Homepage/share', { type: type });
      __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].showShareWindow({
        shareInfoUrl: location.protocol + '//' + location.host + '/wenan/api/groups/' + this.wenanId,
        trigger: this.shareCallback
      });
    },
    onStatusChange: function onStatusChange() {
      if (this.status === 1) {
        if (this.isGaosan) {
          __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].setTitle('2019高考真题在线估分');
          this.wenanId = /\.biz/.test(location.host) ? 255 : 1477;
        } else {
          __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].setTitle('2019高考真题挑战赛');
          this.wenanId = /\.biz/.test(location.host) ? 257 : 1475;
        }
        __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].setRightButton({
          hidden: false,
          text: '分享',
          trigger: this.onShare,
          image: 'iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAQdJREFUaAXt1EEOgjAQhWFb9y45gpGz6Dk8B4fSW7hyA4lX4AzgTOIQjA5N04QF+UlIy3QeaT8Nux0XAggggAACCCCAAAIIIIAAAggggAACCCCAwKYEQu5p6ro+j+PYSO4kdxdCaNq2vafes3bO9pN1QN3kMAw3C9sYY7wsHXLtnO1Lxzh/SM0/v9xPm1e3Rm/dq5fmLK9j1gGlX/+W/y6vbr3eulcvzVk++4DdlPyeeHXr8ta9emnO8nkH1A/KlJxNvLq1eOtevTRneR3384fUvO/7V1VVD+k7yuYOcj/lA3Nd+sDoO9fOpc7BOgIIIIAAAggggAACCCCAAAIIIIAAAgggsGWBN7tQbSsQFGljAAAAAElFTkSuQmCC'
        });
      } else {}
    },
    checkLogin: function checkLogin(callback) {
      var _this6 = this;

      if (this.isLogin) {
        callback();
      } else {
        __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getUser().then(function (res) {
          window.ytkUserId = res.body.id;
          if (!res.body.trial) {
            _this6.isLogin = true;
            callback();
          } else {
            _this6.login();
          }
        }).catch(function () {
          _this6.login();
        });
      }
    },
    login: function login() {
      if (/yuanfudao|yuantiku|yuansouti/i.test(navigator.userAgent)) {
        window.YTK_API.login({
          callback: function callback() {
            window.location.reload();
          }
        }, function () {
          window.location.reload();
        });
      } else {
        window.location.href = '/h5/ape-web-login/?redirect=' + encodeURIComponent(window.location.href);
      }
    },
    gotoUrl: function gotoUrl() {
      window.location.href = 'https://ytk.yuanfudao.com/ape-web-page/3343';
    }
  }
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountDown__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CountDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_estimate__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_query__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ua__ = __webpack_require__(121);











var query = __WEBPACK_IMPORTED_MODULE_4__utils_query__["a" /* default */].parse();
var shareMap = {
  qq: '/click/evaluate2019/shareToQQ',
  qzone: '/click/evaluate2019/shareToQzone',
  wechat: '/click/evaluate2019/shareToWeixin',
  moments: '/click/evaluate2019/shareToMoments',
  weibo: '/click/evaluate2019/shareToWeibo'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'personal',
  components: { CountDown: __WEBPACK_IMPORTED_MODULE_0__CountDown___default.a, Loading: __WEBPACK_IMPORTED_MODULE_1__Loading___default.a },
  props: ['majorId', 'quizId'],
  created: function created() {
    var _this = this;

    this.setShare();
    console.log('test');
    if (__WEBPACK_IMPORTED_MODULE_6__utils_ua__["a" /* default */].isYuanSouTi()) {
      __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getSolarUser().then(function (res) {
        if (res.body.trial) {
          _this.login();
          return false;
        }
        _this.userId = res.body.ytkUserId;
        window.ytkUserId = res.body.ytkUserId;
        window.solarUserId = res.body.userId;
        return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getEstimate(res.body.ytkUserId, _this.majorId, _this.quizId);
      }, function (err) {
        if (err.status === 401) {
          _this.login();
        }
      }).then(function (res) {
        if (!res || !res.body) {
          return false;
        }
        _this.estimate = res.body;
        _this.paperEstimates = _this.estimate.paperEstimates;
        if (_this.paperEstimates) {
          var hasEstimate = false;
          _this.paperEstimates.map(function (es) {
            if (es.status !== 0) {
              hasEstimate = true;
              _this.hasEstimate = hasEstimate;
            }
          });
          var evaluate = _this.hasEstimate ? 1 : 0;
          _this.$addFrog('/event/evaluate2019/enter', { evaluate: evaluate, courseid: _this.estimate.majorId, provinceid: _this.estimate.quizId });
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getUser().then(function (res) {
        if (res.body.trial) {
          _this.login();
          return false;
        }
        _this.userId = res.body.id;
        window.ytkUserId = res.body.id;
        return __WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getEstimate(res.body.id, _this.majorId, _this.quizId);
      }, function (err) {
        if (err.status === 401) {
          _this.login();
        }
      }).then(function (res) {
        if (!res || !res.body) {
          return false;
        }
        _this.estimate = res.body;
        _this.paperEstimates = _this.estimate.paperEstimates;
        if (_this.paperEstimates) {
          var hasEstimate = false;
          _this.paperEstimates.map(function (es) {
            if (es.status !== 0) {
              hasEstimate = true;
              _this.hasEstimate = hasEstimate;
            }
          });
        }
        var evaluate = _this.hasEstimate ? 1 : 0;
        _this.$addFrog('/event/evaluate2019/enter', { evaluate: evaluate, courseid: _this.estimate.majorId, provinceid: _this.estimate.quizId });
      });
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      estimate: null,
      hasEstimate: false,
      userId: null,
      keyfrom: query.keyfrom,
      isGaosan: Number(query.isGaosan),
      wenanId: 255,
      appId: __WEBPACK_IMPORTED_MODULE_6__utils_ua__["a" /* default */].getAppId(),
      fromStr: '' + (query.from ? '&from=' + query.from : ''),
      keyfromStr: '' + (query.keyfrom ? '&keyfrom=' + query.keyfrom : '')
    };
  },

  methods: {
    shareCallback: function shareCallback(err, platform) {
      console.log(err, platform);
      this.$addFrog(shareMap[platform]);
    },
    onShare: function onShare() {
      this.$addFrog('/click/evaluate2019/share', { courseid: this.estimate.majorId, provinceid: this.estimate.quizId });
      __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].showShareWindow({
        shareInfoUrl: location.protocol + '//' + location.host + '/wenan/api/groups/' + this.wenanId,
        trigger: this.shareCallback
      });
    },
    setShare: function setShare() {
      __WEBPACK_IMPORTED_MODULE_5__solar_common_webview__["a" /* default */].setRightButton({
        hidden: true
      });
    },
    enterPaper: function enterPaper(paperid) {
      var _this2 = this;

      console.log('paperid', paperid);
      var hasEstimate = this.hasEstimate;

      var evaluate = hasEstimate ? 1 : 0;
      this.$addFrog('/click/evaluate2019/report', { evaluate: evaluate, paperid: paperid, courseid: this.estimate.majorId, provinceid: this.estimate.quizId });
      setTimeout(function () {
        window.location.href = '/h5/ape-web-homework_estimate/report.html?userId=' + _this2.userId + '&isGaosan=' + _this2.isGaosan + '&paperId=' + paperid + _this2.fromStr + _this2.keyfromStr;
      }, 100);
    },
    getEstimateScore: function getEstimateScore(paperEstimates) {
      return __WEBPACK_IMPORTED_MODULE_3__utils_estimate__["a" /* default */].getEstimateScore(paperEstimates);
    },
    getPaperScore: function getPaperScore(paperEstimate) {
      return __WEBPACK_IMPORTED_MODULE_3__utils_estimate__["a" /* default */].getPaperScore(paperEstimate);
    },
    login: function login() {
      if (/yuanfudao|yuantiku|yuansouti/i.test(navigator.userAgent)) {
        window.YTK_API.login({
          callback: function callback() {
            window.location.href = window.location.href;
          }
        });
      } else {
        window.location.href = '/h5/ape-web-login/?redirect=' + window.location.href;
      }
    }
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(59);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'web-page',
  data: function data() {
    return {
      numbers: [0, 0, 0, 0, 0, 0]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getEstimateStat(855, 1).then(function (res) {
      var userCount = '' + res.body.userCount;
      var count = '0'.repeat(6 - userCount.length) + userCount;
      _this.numbers = count.split('');
    });
  },


  methods: {
    gotoUrl: function gotoUrl() {
      window.location.href = 'https://ytk.yuanfudao.com/ape-web-page/3343';
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(445)

var Component = __webpack_require__(32)(
  /* script */
  null,
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(447)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  "data-v-54281412",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(446)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  "data-v-26b0c77c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(444)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  "data-v-003d19a7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(478),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(448)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  "data-v-58d8efb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(449)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(476),
  /* scopeId */
  "data-v-b318a136",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(450)

var Component = __webpack_require__(32)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(477),
  /* scopeId */
  "data-v-c2c15624",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  })
},staticRenderFns: []}

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.already) ? _c('a', {
    staticClass: "paper-active",
    on: {
      "click": _vm.enterPaper
    }
  }, [_vm._v("开始估分")]) : _c('span', {
    staticClass: "paper-active"
  }, [_vm._v(_vm._s(_vm.diffTime))])])
},staticRenderFns: []}

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell city-cell",
    class: {
      active: _vm.quiz.id === _vm.quizId,
        disabled: _vm.disabled
    },
    on: {
      "click": _vm.selectQuiz
    }
  }, [_vm._v("\n  " + _vm._s(_vm.quiz.name) + "\n  "), _c('div', {
    staticClass: "city-paper"
  }, [_vm._v(_vm._s(_vm.quiz.examTypeName))])])
},staticRenderFns: []}

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-page"
  }, [(_vm.status === 1) ? _c('div', [_c('div', {
    staticClass: "mobile-header"
  }, [_c('div', {
    staticClass: "mobile-title"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '2019高考真题在线估分' : '2019高考真题挑战赛'))]), _vm._v(" "), _c('div', {
    staticClass: "estimate-num"
  }, _vm._l((_vm.numbers), function(n) {
    return _c('span', [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mobile-desc"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '在线估分考生人数' : '在线挑战人数'))]), _vm._v(" "), _c('div', {
    staticClass: "waves"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mobile-content"
  }, [(_vm.estimateStat) ? _c('div', [_c('div', {
    staticClass: "quiz-info"
  }, [_vm._v(_vm._s(_vm.estimateStat.quiz.name) + "\n        " + _vm._s(_vm.estimateStat.major.id === 0 ? '' : ("(" + (_vm.estimateStat.major.name) + ")")))]), _vm._v(" "), _c('div', {
    staticClass: "change-quiz",
    on: {
      "click": function($event) {
        return _vm.changeQuiz('change')
      }
    }
  }, [_vm._v("更换考试省份")])]) : _c('div', {
    staticClass: "change-quiz choose",
    on: {
      "click": function($event) {
        return _vm.changeQuiz('init')
      }
    }
  }, [_vm._v("请选择考试省份")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "quiz-num"
  }, [_vm._v(_vm._s(_vm.estimateStat ? _vm.estimateStat.quizUserCount : 0))]), _vm._v(" "), _c('div', {
    staticClass: "quiz-tip"
  }, [_vm._v(_vm._s(_vm.isGaosan ? '参与估分人数' : '参与挑战人数'))]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "quiz-num"
  }, [_vm._v(_vm._s(_vm.estimateStat ? _vm.estimateStat.topUserCount : 0))]), _vm._v(" "), _c('div', {
    staticClass: "quiz-tip"
  }, [_vm._v("高于 " + _vm._s(_vm.estimateStat ? _vm.estimateStat.threshold : 0) + " 分人数")]), _vm._v(" "), _c('div', {
    staticClass: "footer-btn"
  }, [_c('button', {
    class: {
      disabled: !_vm.estimateStat
    },
    on: {
      "click": _vm.startEstimate
    }
  }, [_vm._v(_vm._s(_vm.isGaosan ? '开始估分' : '开始挑战'))])])]), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        return _vm.gotoUrl()
      }
    }
  }, [_vm._v("北京贞观雨科技有限公司版权所有 关于我们")])]) : (_vm.status === 2) ? _c('div', [_c('div', {
    staticClass: "select-content"
  }, [_c('div', {
    staticClass: "select-title"
  }, [_vm._v("文理分科")]), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, _vm._l((_vm.majors), function(m, index) {
    return _c('div', {
      key: index,
      staticClass: "cell major-cell",
      class: {
        active: m.id === _vm.majorId
      },
      on: {
        "click": function($event) {
          _vm.majorId = m.id
        }
      }
    }, [_vm._v(_vm._s(m.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-title"
  }, [_vm._v("选择省份")]), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, _vm._l((_vm.quizzes), function(quiz) {
    return _c('city-cell', {
      key: quiz.id,
      attrs: {
        "quiz": quiz,
        "majorId": _vm.majorId,
        "quizId": _vm.quizId
      },
      on: {
        "select": function($event) {
          return _vm.selectSubject(quiz)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "confirm-btn"
  }, [_c('button', {
    class: {
      disabled: !_vm.confirm
    },
    on: {
      "click": _vm.confirmSelect
    }
  }, [_vm._v("确定")])])]) : _c('div', {
    staticClass: "personal"
  }, [(_vm.status == 3) ? _c('personal', {
    attrs: {
      "majorId": _vm.majorId,
      "quizId": _vm.quizId
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.estimate) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [(_vm.hasEstimate) ? _c('div', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.getEstimateScore(_vm.estimate.paperEstimates)))]) : _c('div', {
    staticClass: "no-score"
  }, [_vm._v("暂无估分")]), _vm._v(" "), _c('div', {
    staticClass: "header-desc"
  }, [_vm._v("我的总分")])]), _vm._v(" "), _c('div', {
    staticClass: "personal-info"
  }, [_c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "rank-place"
  }, [_vm._v(_vm._s(_vm.hasEstimate ? _vm.estimate.rank : '— —'))]), _vm._v(" "), _c('div', {
    staticClass: "info-name"
  }, [_vm._v("全省排名")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "beat"
  }, [_c('div', {
    staticClass: "rate"
  }, [(_vm.hasEstimate) ? _c('span', [_vm._v(_vm._s((100 * _vm.estimate.beatRate).toFixed(0)) + "%")]) : _c('span', [_vm._v("— —")])]), _vm._v(" "), _c('div', {
    staticClass: "info-name"
  }, [_vm._v("击败的考生")])])]), _vm._v(" "), _c('div', {
    staticClass: "paper-list"
  }, _vm._l((_vm.estimate.paperEstimates), function(paper, index) {
    return _c('div', {
      key: index,
      staticClass: "paper-item"
    }, [_c('div', {
      staticClass: "paper-content"
    }, [_c('span', [_vm._v(_vm._s(paper.courseName) + "\n          "), (paper.categoryName) ? _c('span', {
      staticClass: "paper-name"
    }, [_vm._v("(" + _vm._s(paper.categoryName) + ")")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "paper-enter"
    }, [(paper.status === 1) ? _c('a', {
      staticClass: "paper-done",
      on: {
        "click": function($event) {
          return _vm.enterPaper(paper.paperId)
        }
      }
    }, [_vm._v(_vm._s(_vm.getPaperScore(paper)) + "分")]) : _vm._e(), _vm._v(" "), (paper.status === 0) ? _c('span', [(paper.openingTime === 0) ? _c('span', {
      staticClass: "disabled"
    }, [_vm._v("即将开始")]) : _c('count-down', {
      attrs: {
        "deadline": paper.openingTime,
        "paperId": paper.paperId
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "icon-right"
    })])])])
  }), 0)]) : _c('div', [_c('Loading')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "web-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2019高考真题在线估分")]), _vm._v(" "), _c('div', {
    staticClass: "estimate-num"
  }, _vm._l((_vm.numbers), function(n) {
    return _c('span', [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("在线估分考生人数")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        return _vm.gotoUrl()
      }
    }
  }, [_vm._v("北京贞观雨科技有限公司版权所有 关于我们")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "web-logo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ercode"
  }, [_c('p', [_vm._v("扫码闪电估分")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "114",
      "height": "114",
      "src": "//gallery.fbcontent.cn/api/ape/images/15bfc571794b116.png",
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMobile) ? _c('mobile-page') : _c('web-page')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
module.exports = __webpack_require__(170);


/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(118);



/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: function getUser() {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/accounts/api/current?_productId=131').withCredentials();
  },
  getSolarUser: function getSolarUser() {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].YST_HOST + '/user-profile/api/userGrades').query().withCredentials();
  },
  getUserInfo: function getUserInfo() {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/profile/api/user-info?_productId=131').withCredentials();
  },
  getUserEstimateInfo: function getUserEstimateInfo() {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/ape-estimate/api/estimates/setting?_productId=131').withCredentials();
  },
  getQuizzes: function getQuizzes() {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/ape-baggins/api/quizzes?_productId=131&phaseId=2').withCredentials();
  },
  getEstimate: function getEstimate(userId, majorId, quizId) {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/ape-estimate/api/users/' + userId + '/estimate?_productId=131&majorId=' + majorId + '&quizId=' + quizId).withCredentials();
  },
  getEstimateStat: function getEstimateStat(quizId, majorId) {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.get('/ape-estimate/api/estimate-stat?_productId=131&quizId=' + quizId + '&majorId=' + majorId).withCredentials();
  },
  setUserInfo: function setUserInfo(quizId, majorId) {
    return __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.put('/ape-estimate/api/estimates/setting?_productId=131').query({
      quizId: quizId,
      major: majorId
    }).withCredentials();
  }
});

/***/ })

},[483]);


// WEBPACK FOOTER //
// static/js/app.8e4af43ec02ddfdcd53f.js